<template>
    <default-item class="christmas_food_item--container" :item="item" :pricing-types="pricingTypes"
                  :layout="priceLayout"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for Christmas food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2024-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2024-12-09 (1.0.0) (jhoward)
 *      - <newYearsFoodItem> copied to <christmasFoodItem>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <christmasFoodItem>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'christmas-food-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<'price-inline' | 'price-below'>,
      default: 'price-inline'
    }
  },
})
</script>

<style scoped>
.christmas_food_item--container {
  text-align: center;
}

.christmas_food_item--container:deep(.menu--item_description p) {
  font-weight: lighter;
}

.christmas_food_item--container:deep(.menu--item_description p:first-child) {
  margin-top: 0;
}

.christmas_food_item--container.menu--item:not(.menu--item-multi_line_price) {
  line-height: 1em;
}

.menu--item:deep(.menu--item_description) {
  margin-top: 0;
}

.christmas_food_item--container:deep(.menu--tag) {
  right: -0.4em;
  margin: 0;
  font-size: 2.8em;
}
</style>